import { DocumentNode } from 'graphql';
import gql from 'graphql-tag';

const getWaitTimesQuery: DocumentNode = gql`
  query GetWaitTimes($userProfile: UserProfileIdInput!) {
    waitTimes(userProfile: $userProfile) {
      chat {
        availabilityMode
        inboxKey
        isAdvocateAvailable
        lastUpdatedOn
        queue
        waitTimeInMinutes
      }
      sms {
        availabilityMode
        inboxKey
        isAdvocateAvailable
        lastUpdatedOn
        queue
        waitTimeInMinutes
      }
    }
  }
`;

export default getWaitTimesQuery;
